/**
 * Masks a sensitive string, showing only the first and last few characters.
 * e.g. "eyJhbGciOiJIUzI1NiJ9" → "eyJh********UzI1"
 */
export const maskSensitiveValue = (value: string, visibleChars = 4): string => {
  if (value.length <= visibleChars * 2) return "****";
  return `${value.slice(0, visibleChars)}${"*".repeat(8)}${value.slice(-visibleChars)}`;
};
